import React from 'react';
import { connect } from 'react-redux';

import { changeCollectionQuantity } from '../actions';
import CollectionPendingQuantityInput from '../components/CollectionPendingQuantityInput';

const mapStateToProps = (state, props) => {
  const { collectionsPending } = state;
  const collectionItemPending = collectionsPending.find(
    item => item.id === props.collection.id
  );

  const quantityPending = collectionItemPending
    ? collectionItemPending.quantity
    : 0;

  return {
    quantityPending,
  };
};

const mapDispatchToProps = dispatch => ({
  changeCollectionQuantity: (collection, quantity) => {
    dispatch(changeCollectionQuantity(collection, quantity));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(
  CollectionPendingQuantityInput
);



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/containers/CollectionPendingQuantityInput.js